import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: 'var(--onSurfaceMuted)',
    marginTop: 4,
  },
  errorText: {
    fontSize: 14,
    color: 'var(--errorText)',
    margin: 0,
  },
  actionsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 14,
  },
});
